<template>
  <div>
    <el-dialog class="dialogImgShow" :before-close="close"
               :visible.sync="dialogOrderImgVisible">
      <div>
        <!--<el-carousel :autoplay="false" arrow="always" :initial-index='eleId'>
          <el-carousel-item v-for="(img,index) in imgSrc"  :key="img">
            　　　　<img :src="img.imageUrl" alt="" style="width: 100%;height: 100%">
          </el-carousel-item>
        </el-carousel>-->
        <swiper :options="swiperOption" ref="mySwiper">
          　　<swiper-slide v-for="(img,index) in imgSrc"  :key="index" style="height: 460px" >
          　　　　<img :src="img.imageUrl" alt="" style="width: 100%;height: 100%">
          　　</swiper-slide>
          　　<div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import bus from '../../assets/js/bus'
  import Swiper from 'swiper';
  // import 'swiper/dist/css/swiper.css';
  export default({
    data(){
      return{
        dialogOrderImgVisible:false,
        swiperOption: {
          notNextTick: true,
          pagination: '.swiper-pagination',
          paginationClickable: true,
          initialSlide:0,
          direction:'horizontal',
          loop: true,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          prevButton:'.swiper-button-prev',
          nextButton:'.swiper-button-next',
          preloadImages: true,
          updateOnImagesReady : true,
          coverflow: {
            rotate: 30,
            stretch: 10,
            depth: 60,
            modifier: 2,
            slideShadows : true,
            // slidesPerView:3
          },
          mySwiper:undefined
        },
        eleId:undefined,
        imgSrc:[]
      }
    },
    computed: {
      /*mySwiper() {
        return this.$refs.mySwiper.swiper
      }*/
    },
    updated(){
      var that = this;
      that.mySwiper = that.$refs.mySwiper.swiper
      //console.log(that.mySwiper)
    },
    mounted(){
      this.$nextTick(function(){
        var that = this;
        bus.$on('showDialogOrderImgShow', function (data) {
          //console.log(data)
          that.imgSrc = data.imgSrc;
          that.swiperOption.initialSlide = data.eleId;
          that.dialogOrderImgVisible = true;
        });
      })
    },
    methods:{
      init(){
        this.mySwiper.init();
      },
      close(){
        this.eleId=undefined;
        this.dialogOrderImgVisible = false
      }
    },
    watch:{
      'dialogOrderImgVisible': {
        handler: function (newVal, oldVal) {
          var that = this;
          if(newVal){
            // that.mySwiper.init();
          }else{
            // this.mySwiper.init();
          }
        },
        deep: true
      }
    }
  })
</script>

<style  lang="scss">
  @import'../../assets/css/swiper-3.4.2.min.css';
  .dialogImgShow{
    .el-dialog--small{
      width: 720px!important;
    }
    .el-dialog .el-dialog__body{
      padding: 30px 20px;
    }
    .el-carousel__button {
      height: 4px;
    }
    .resize-triggers{
      display: none;
    }
    .el-carousel__item h3 {
      color: #475669;
      font-size: 14px;
      opacity: 0.75;
      line-height: 150px;
      margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
      background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n+1) {
      background-color: #d3dce6;
    }
  }
</style>



// WEBPACK FOOTER //
// dialogOrderImg.vue?1a4dd448